<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The British author, Joey Marcelle was born in 1988 and raised in Manchester, England. <em>Nothing Is as It Seems</em> is the first of what hopes to be a series of books. With a strong passion for creativity, Joey Marcelle works within the entertainment industry. The book was created from her passion and love of reading thrillers. <em>Nothing Is as It Seems</em> is an action-fuelled plot that is thought-provoking, gripping, full of suspense and encompasses a variety of themes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4b691b4e